import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

const EditSubmitButton = ({ handleSubmit, validity, isLoading }: any) => {
  return (
    <div className="flex w-full justify-center">
      <button
        onClick={handleSubmit}
        disabled={!validity || isLoading}
        className={`text-white p-[16px] w-[670px] font-bold rounded-md ease-in-out duration-300 ${
          !validity || isLoading ? "bg-brown opacity-50" : "bg-orange"
        }`}
      >
        {isLoading ? (
          <Spin
            className="text-white"
            size="default"
            indicator={<LoadingOutlined spin />}
          />
        ) : (
          "Submit"
        )}
      </button>
    </div>
  );
};

export default EditSubmitButton;
